/**
 * 角色分配模态框配置
 */
import type { TableColumnConfig } from "@ms/shared-components/components/GenericModalTable";

/**
 * 角色表格列配置
 */
export const roleTableColumns: TableColumnConfig[] = [
  {
    title: "角色名称",
    dataIndex: "role_name",
    key: "role_name",
  },
  {
    title: "角色代码",
    dataIndex: "role_code",
    key: "role_code",
    render: (code: string) => code || "无",
  },
  {
    title: "描述",
    dataIndex: "description",
    key: "description",
    render: (description: string) => description || "无描述",
  },
];

/**
 * 模态框配置
 */
export const assignRoleModalConfig = {
  width: 800,
  size: "small" as const,
  scroll: { y: 400 },
  saveButtonText: "保存",
  modalProps: {
    destroyOnHidden: true,
  },
};

/**
 * 选择配置
 */
export const selectionConfig = {
  enabled: true,
  type: "checkbox" as const,
};
